export enum EHeader {
  simple = 'simple',
  advanced = 'advanced',
}
